"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _warning = _interopRequireDefault(require("warning"));

var _inputBase = _interopRequireDefault(require("../input-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Input = function Input(_ref) {
  var className = _ref.className,
      disabled = _ref.disabled,
      errorState = _ref.error,
      focused = _ref.focused,
      id = _ref.id,
      inputClassName = _ref.inputClassName,
      inputComponent = _ref.inputComponent,
      inputRef = _ref.inputRef,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      placeholder = _ref.placeholder,
      required = _ref.required,
      type = _ref.type,
      value = _ref.value,
      warning = _ref.warning,
      restOfInputProps = _objectWithoutProperties(_ref, ["className", "disabled", "error", "focused", "id", "inputClassName", "inputComponent", "inputRef", "onBlur", "onChange", "onFocus", "placeholder", "required", "type", "value", "warning"]);

  var textInput = _react.default.createRef();

  var handleBlur = function handleBlur(e) {
    if (typeof onBlur === 'function') {
      onBlur(e);
    }
  };

  var handleInputChange = function handleInputChange(e) {
    var targetValue = e.target.value;
    /**
     * Expose `rawValue` and `formattedValue` to keep it consistent with formatted input components,
     * but only if there isn't an `inputComponent` used; otherwise, this will override it
     */

    if (!inputComponent) {
      e.target.rawValue = targetValue;
      e.target.formattedValue = targetValue;
    }

    if (typeof onChange === 'function') {
      onChange(e);
    }
  };

  var setInputRef = function setInputRef(inputElement) {
    textInput = inputElement;
  };

  var handleFocus = function handleFocus(e) {
    var inputReference = textInput;

    if (inputReference.current && typeof inputReference.current.focus === 'function') {
      inputReference.current.focus();
    }

    if (typeof onFocus === 'function') {
      onFocus(e);
    }
  };

  var warningState = warning;
  /**
   * We cannot have both warning and error state be true for the input field
   * Default to using the error state instead
   */

  if (warningState && errorState) {
    (0, _warning.default)(!warningState && errorState, 'PDS::INPUT: warning and error cannot both be set to true; using error instead.');
    warningState = false;
  }

  var inputWrapperClassName = (0, _classnames.default)(className, {
    'pds-input-base-wrapper': true,
    'pds-input-base-wrapper--disabled': disabled,
    'pds-input-base-wrapper--error': errorState,
    'pds-input-base-wrapper--warning': warningState
  });
  var inputClassNames = (0, _classnames.default)(inputClassName, {
    'pds-input-base--text': true,
    'pds-input-base--text--error': errorState,
    'pds-input-base--text--warning': warningState
  });
  var inputProps = {};
  /**
   * Supply a ref internally to the native input element
   */

  inputProps.ref = textInput;
  inputProps['aria-required'] = required;
  return _react.default.createElement("div", {
    className: "pds-input-wrapper",
    onBlur: handleBlur,
    role: "none"
  }, _react.default.createElement(_inputBase.default // Base input props that goes directly down to input field from our FEBE
  , _extends({}, restOfInputProps, inputProps, {
    id: id,
    className: inputWrapperClassName,
    disabled: disabled,
    inputComponent: inputComponent,
    inputClassName: inputClassNames,
    inputRef:
    /**
     * Users can supply an inputRef handler to access the input element,
     * or we provide one by default
     */
    typeof inputRef === 'function' ? inputRef : setInputRef,
    placeholder: placeholder,
    onChange: handleInputChange,
    type: type,
    onFocus: handleFocus,
    required: required,
    value: value
  })));
};

Input.propTypes = {
  // "aria-invalid" accepts true/false as a boolean, and grammar/spelling as a string
  // See: https://github.com/evcohen/eslint-plugin-jsx-a11y/issues/125

  /**
   * Accessibility label describing the current validity of the input element.
   * The `true` or `false` values must be in a boolean form.
   */
  'aria-invalid': (0, _propTypes.oneOf)(['grammar', 'spelling', true, false]).isRequired,

  /**
   * Applies additional CSS classes to the wrapper of the `InputBase`
   * component.
   */
  className: _propTypes.string,

  /**
   * Whether or not the input element is editable.
   */
  disabled: _propTypes.bool,

  /**
   * Applies error state styling to the `InputBase` component. This cannot
   * be true if `warning` is set to true.
   */
  error: _propTypes.bool,
  focused: _propTypes.bool,
  id: _propTypes.string,
  inputClassName: _propTypes.string,
  inputComponent: (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.object]),

  /**
   * A function to be passed to the InputComponent to access the native
   * input element.
   */
  inputRef: _propTypes.func,

  /**
   * Adds an additional onBlur handler to the wrapper of the InputBase
   * component.
   */
  onBlur: _propTypes.func,

  /**
   * Adds an additional onChange handler to the InputBase component.
   */
  onChange: _propTypes.func,

  /**
   * Adds an additional onFocus handler to the InputBase component.
   */
  onFocus: _propTypes.func,

  /**
   * Adds placeholder text to the HTML input element.
   */
  placeholder: _propTypes.string,

  /**
   * Whether or not the HTML input is required before a form submission
   * can occur.
   */
  required: _propTypes.bool,

  /**
   * The type of input field. Type must a valid HTML5 supported type.
   * See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input
   * for all available options.
   */
  type: _propTypes.string,

  /**
   * Explicit value to set on the controlled input element.
   */
  value: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object]),

  /**
   * Applies warning state styling to the `InputBase` component. This
   * cannot be true if `error` is set to true.
   */
  warning: _propTypes.bool
};
Input.defaultProps = {
  className: null,
  disabled: false,
  error: false,
  focused: false,
  id: null,
  inputClassName: null,
  inputComponent: undefined,
  inputRef: null,
  onBlur: null,
  onChange: null,
  onFocus: null,
  placeholder: '',
  required: false,
  type: 'text',
  value: undefined,
  warning: false
};
var _default = Input;
exports.default = _default;
